/**
 * @fileoverview Gather Information — section overview route
 *
 * URL: /dashboard/jobs/:jobId/gather-information
 *
 * Landing page for the "Gather Information" sidebar accordion group. Mirrors
 * the Data (/summaries) and Investigations (/review) overviews so all three
 * groups are navigable and highlight consistently. Cards link out to Searches,
 * Day One, and Files.
 */

import { createFileRoute } from "@tanstack/react-router";
import { GatherInformationOverview } from "@/components/jobs/phases/gather/GatherInformationOverview";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/gather-information",
)({
  component: GatherInformationPage,
});

function GatherInformationPage() {
  const { jobId } = Route.useParams();

  // Replicate the `p-6` shell used by the Data / Investigations overviews so
  // GatherInformationOverview's `-m-6` background bleed lines up.
  return (
    <div className="flex min-h-full flex-1 flex-col">
      <div className="flex min-h-full flex-1 flex-col p-6">
        <GatherInformationOverview jobId={jobId} />
      </div>
    </div>
  );
}
